module.exports = __webpack_public_path__ + "static/media/8.95956482.jpg";